/**
 * Utility per la generazione di URL SEO-friendly
 */

/**
 * Genera uno slug SEO-friendly da un titolo
 * @param {string} title - Il titolo da convertire in slug
 * @returns {string} - Lo slug generato
 */
export const generateSlug = (title) => {
  if (!title) return '';

  return title
    .toLowerCase()
    // Rimuove accenti e caratteri speciali
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    // Sostituisce spazi con trattini
    .replace(/\s+/g, '-')
    // Rimuove caratteri non alfanumerici eccetto trattini
    .replace(/[^a-z0-9-]/g, '')
    // Rimuove trattini multipli
    .replace(/-+/g, '-')
    // Rimuove trattini all'inizio e alla fine
    .replace(/^-+|-+$/g, '')
    // Limita la lunghezza dello slug
    .substring(0, 80);
};

/**
 * Estrae l'ID dall'URL con slug
 * @param {string} slugUrl - URL con slug, es: "1719494400000-titolo-articolo"
 * @returns {string} - L'ID estratto
 */
export const extractIdFromSlug = (slugUrl) => {
  if (!slugUrl) return null;

  // L'ID è la prima parte dello slug, prima del primo trattino
  const idMatch = slugUrl.match(/^([^-]+)/);

  return idMatch ? idMatch[1] : null;
};

/**
 * Crea un URL SEO-friendly combinando ID e titolo
 * @param {string} id - L'ID dell'articolo
 * @param {string} title - Il titolo dell'articolo
 * @returns {string} - URL SEO-friendly
 */
export const createSeoUrl = (id, title) => {
  if (!id) return '';

  const slug = generateSlug(title);
  return slug ? `${id}-${slug}` : id;
};
